import get from "lodash/get";
import analyticsService from "~/service/analyticsService";
import { mapActions, mapState } from "vuex";

export default {
  props: {
    giftCertificate: { type: Object, required: true }
  },
  computed: {
    name() {
      return get(
        this.giftCertificate,
        "categoryProposal.name",
        this.giftCertificate.name
      );
    },
    tagLabel() {
      return get(
        this.giftCertificate,
        "categoryProposal.metaData.category_proposal_type.TAG_LABEL",
        this.name
      );
    },
    shortDescription() {
      return get(
        this.giftCertificate,
        "categoryProposal.metaData.category_proposal_type.SHORT_DESCRIPTION",
        this.description
      );
    },
    description() {
      return get(
        this.giftCertificate,
        "categoryProposal.content",
        this.giftCertificate.description
      );
    },
    cssClass() {
      return get(
        this.giftCertificate,
        "categoryProposal.metaData.category_proposal_type.CSS_CLASS",
        "pink"
      );
    },
    hideEndDate() {
      return get(
        this.giftCertificate,
        "categoryProposal.metaData.category_proposal_type.HIDE_END_DATE",
        false
      );
    },
    icon() {
      return get(
        this.giftCertificate,
        "categoryProposal.metaData.category_proposal_type.ICON",
        "$percent"
      );
    },
    src() {
      // img for gift card and gift row
      return get(
        this.giftCertificate,
        "categoryProposal.metaData.category_proposal_type.IMAGE_DESKTOP"
      );
    },
    srcMobile() {
      // img for gift code widget homepage
      return get(
        this.giftCertificate,
        "categoryProposal.metaData.category_proposal_type.IMAGE_MOBILE"
      );
    },
    btnLabel() {
      return get(
        this.giftCertificate,
        "categoryProposal.metaData.category_proposal_type.BTN_LABEL",
        this.$t("profile.gifts.more")
      );
    },
    link() {
      if (get(this.giftCertificate, "categoryProposal.proposalUrl")) {
        return this.giftCertificate.categoryProposal.proposalUrl;
      } else if (get(this.giftCertificate, "categoryProposal.slug")) {
        return {
          name: "Category",
          params: {
            pathMatch: this.giftCertificate.categoryProposal.slug
          }
        };
      } else {
        return null;
      }
    },
    isAssignable() {
      return !!this.giftCertificate.giftCode;
    },
    userGiftCertificateId() {
      let userGiftCertificateId = null;

      if (this.giftCertificate.userGiftCertificates?.length > 0) {
        this.giftCertificate.userGiftCertificates.every(userGiftCertificate => {
          if (userGiftCertificate.cartId == this.cart.cartId) {
            userGiftCertificateId = userGiftCertificate.userGiftCertificateId;
            return false;
          }
        });
      } else if (this.giftCertificate.giftCertificateId) {
        this.cart.giftCertificates.every(userGiftCertificate => {
          if (
            userGiftCertificate.giftCertificateId ===
            this.giftCertificate.giftCertificateId
          ) {
            userGiftCertificateId = userGiftCertificate.userGiftCertificateId;
            return false;
          }
        });
      }
      return userGiftCertificateId;
    },
    listUsedCertificates() {
      if (this.giftCertificate.userGiftCertificates?.length > 0) {
        return this.giftCertificate.userGiftCertificates.filter(
          userGiftCertificate => {
            return userGiftCertificate.orderId;
          }
        );
      } else {
        return [];
      }
    },
    listAvailableCertificates() {
      if (this.giftCertificate.userGiftCertificates?.length > 0) {
        return this.giftCertificate.userGiftCertificates.filter(
          userGiftCertificate => {
            return !userGiftCertificate.orderId;
          }
        );
      } else {
        return [];
      }
    },
    ...mapState({
      cart: ({ cart }) => cart.cart
    })
  },
  methods: {
    ...mapActions({
      addGiftCode: "cart/addGiftCode",
      sendGiftCode: "cart/sendGiftCode",
      removeGiftCode: "cart/removeGiftCode"
    }),
    async addUserGift(userGiftCertificateId) {
      await this.addGiftCode(userGiftCertificateId);
      this.$emit("add");
    },
    async add() {
      // if (this.giftCertificate.userGiftCertificates?.length > 0) {
      //   let userGiftCertificate = this.giftCertificate.userGiftCertificates[0];
      //   await this.addGiftCode(userGiftCertificate.userGiftCertificateId);
      // } else {
      //   await this.sendGiftCode(this.giftCertificate.giftCode);
      // }
      await this.sendGiftCode(this.giftCertificate.giftCode);
      this.$emit("add");
    },
    async remove(userGiftCertificateId) {
      if (userGiftCertificateId) {
        await this.removeGiftCode(userGiftCertificateId);
      } else {
        await this.removeGiftCode(this.userGiftCertificateId);
      }

      //tmp fix emit remove shuold refresh list
      //temporary modificed with add
      //this.$emit("remove");
      this.$emit("add");
    },
    handleClick() {
      if (this.giftCertificate.categoryProposal) {
        //log event to analytics
        analyticsService.clickPromotion(
          this.giftCertificate.categoryProposal,
          this.position
        );
        if (this.giftCertificate.categoryProposal.slug) {
          this.$router.push({
            name: "Category",
            params: { pathMatch: this.giftCertificate.categoryProposal.slug }
          });
        } else if (this.giftCertificate.categoryProposal.proposalUrl) {
          let link = new URL(
            this.giftcertificate.categoryproposal.proposalUrl,
            window.location.href
          );
          //utilizzare stessa tecnica della page per capire se è un link interno o no....
          let path = link.pathname;
          if (link.search) {
            path = `${link.pathname}${link.search}`;
          }
          if (global.config.domainWhitelist.includes(link.hostname)) {
            let resolved = this.$router.resolve({
              path: path
            });
            if (
              resolved &&
              resolved.route.matched.length > 0 &&
              resolved.route.name != "DefaultRoute"
            ) {
              this.$router.push(resolved.route);
            } else {
              if (this.$platform_is_cordova && link.href.indexOf("http") > -1) {
                //if app open on _system browser
                window.cordova.InAppBrowser.open(link.href, "_system");
              }
            }
          } else {
            if (this.$platform_is_cordova && link.href.indexOf("http") > -1) {
              window.cordova.InAppBrowser.open(link.href, "_system");
            }
          }
        }
      }
    }
  }
};
